import { PalmettoOptionGroup, PalmettoOptionProps } from '@palmetto/dsm-components';
import { useState } from 'react';
import { Button, useComponentTracking, useTranslation } from '@helios/frontend-core';


export type SolarManufacturer = 'tesla' | 'enphase' | 'solaredge';

export interface ManufacturerSelectionStepProps {
  setStep: (stepName: string, props?: Record<string, unknown>) => void;
}

const TRACKING_ID = 'takeover-manufacturer-selection-step';
const localePrefix = 'connectSolarSystem';

export function ManufacturerSelectionStep({ setStep }: ManufacturerSelectionStepProps) {
  useComponentTracking(TRACKING_ID);
  const { t } = useTranslation();
  const [selectedManufacturer, setSelectedManufacturer] = useState<SolarManufacturer | undefined>();

  const manufacturerOptions: PalmettoOptionProps[] = [
    {
      value: 'enphase',
      label: t(`${localePrefix}.manufacturers.enphase.label`),
    },
    {
      value: 'tesla',
      label: t(`${localePrefix}.manufacturers.tesla.label`),
    },
    {
      value: 'solaredge',
      label: t(`${localePrefix}.manufacturers.solaredge.label`),
    },
  ];

  const handleContinue = () => {
    if (selectedManufacturer) {
      setStep('oauth-connect', { manufacturer: selectedManufacturer });
    }
  };

  return (
    <div className="flex flex-col max-w-3xl mx-auto px-24 py-32 h-full justify-between">
      <div>
        <div className="heading-600 pb-24">{t(`${localePrefix}.takeover.steps.selectManufacturer.heading`)}</div>
        <div className="flex flex-col">
          <PalmettoOptionGroup
            name="solar_manufacturer"
            type="radio"
            options={manufacturerOptions}
            label={t(`${localePrefix}.takeover.steps.selectManufacturer.label`)}
            value={selectedManufacturer}
            onChange={(e) => setSelectedManufacturer(e.target.value as SolarManufacturer)}
          />
        </div>
      </div>

      <div className="flex flex-col gap-12">
        <Button trackingId={`${TRACKING_ID}-continue`} onClick={handleContinue} disabled={!selectedManufacturer}>
          Continue
        </Button>
      </div>
    </div>
  );
}

export default ManufacturerSelectionStep;
